import BoMenu from '@boComponents/BoMenu';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import * as style from './style.module.css';

const BackOfficeLayout = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className={style.container}>
            <BoMenu isOpen={menuOpen} onToggle={setMenuOpen} />
            {/* When the menu is collapsed, its rail is position:fixed (74px) — offset the content so it isn't hidden behind it. */}
            <div className={`${style.backofficeLayout} ${menuOpen ? '' : style.collapsed}`}>
                <Outlet />
            </div>
        </div>
    );
};

export default BackOfficeLayout;
